/**
 * /admin/* layout route.
 *
 * Parent for every file under `routes/admin/`. The platform-admin area is
 * gated behind `isOwner` (no org role grants it) — that check runs in-tree
 * in RouteRoleGate (src/lib/route-role-gate.tsx), not in a beforeLoad guard,
 * because a beforeLoad guard cannot read the role on cold loads (it runs
 * before MainAppLayout registers it) and deadlocked. The backend still
 * enforces RBAC on every admin API call.
 */
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/admin')({
  component: Outlet,
});
